import React from "react";

import TooltipWrapper from "../toolTipComponent/TooltipWrapper";
import ClickableTooltip from "../toolTipComponent/ClickableTooltip";

const TableMultiValueField = ({
  values,
  label,
  anchorId,
  emptyValue = "-",
  className = "",
  valueClassName = "",
  forceTooltip = false,
}) => {
  const validValues = values.filter(Boolean);

  if (!validValues.length) {
    return <span className={valueClassName}>{emptyValue}</span>;
  }

  //if length of elements is greater than one we will show the count and a tooltip showing there names
  return validValues.length > 1 || forceTooltip ? (
    <>
      <TooltipWrapper>
        <ClickableTooltip
          anchorSelect={`#${anchorId}`}
          className={
            "applies-to-category container-scrollbar category-tooltip-wrapper"
          }
        >
          {validValues.map((value, index) => (
            <div className="applies-to-category" key={index}>
              <li>{value}</li>
            </div>
          ))}
        </ClickableTooltip>
      </TooltipWrapper>

      <button
        type="button"
        id={anchorId}
        className={`action-Button-Wrapper ps-0 ${className}`}
      >
        {validValues.length} {label}
      </button>
    </>
  ) : (
    <div className={valueClassName}>{validValues[0]}</div>
  );
};

export default TableMultiValueField;
